import { getSchemeColor } from '@griply/utils';
import { DefaultTheme } from 'styled-components';

import { ColorScheme } from './theme/color-schemes';

// polished throws on unparseable values — anchored at both ends so trailing junk can't sneak past.
const renderableColorPattern =
  /^(#(?:[0-9a-f]{3}|[0-9a-f]{4}|[0-9a-f]{6}|[0-9a-f]{8})|rgba?\([^)]*\)|hsla?\([^)]*\))$/i;

export const schemeColor = <T extends string | null | undefined>(
  color: T,
  theme: DefaultTheme,
): T => {
  const resolved = getSchemeColor(
    color,
    theme.colorScheme === ColorScheme.Dark,
  );
  if (!resolved || renderableColorPattern.test(resolved)) {
    return resolved;
  }
  return theme.palette.grey[400] as T;
};
